<template>
  <Layout>
    <BaseBreadcrumb :crumbs="breadcrumbs" />
    <BaseSpinner v-show="showSpinner" />
    <div class="body--wrapper mt-1 bg-white container">
      <BaseTitleMenu :heade-title="headerTitle" />

      <div class="my-3">
        <div class=" font-weight-bold" :class="$style.LabelHeading"
          >VOM Details</div
        >
        <div class="row justify-content-md-center">
          <div class="col col-lg-9">
            <b-table-lite :items="items" stacked bordered class="mb-0">
              <template v-slot:cell(accountdetails)="rowitem">
                <div
                  v-for="accountdetail in rowitem.item.accountdetails"
                  :key="accountdetail.accountnumber"
                  class="justify-content-md-center"
                  :class="$style.reasonStyle"
                >
                  <div><b>Account History:</b>
                    <div  class="row justify-content-md-center">
                      <div class="col col-lg-6">
                      <div v-for="accounthistory in accountdetail.accounthistory" :key="accounthistory.date">
                        <div>Amount: {{ accounthistory.amount }}</div>
                        <div>Date: {{ accounthistory.date }}</div>
                        <div>Description: {{ accounthistory.description }}</div>
                        <div>Interest: {{ accounthistory.interest }}</div>
                        <div>Principal: {{ accounthistory.principal }}</div>
                        <div>Trn Type: {{ accounthistory.trnType }}</div>
                        <br>
                      </div>
                      </div>
                    </div>
                  </div>
                  <div><b>Account Number:</b>{{ accountdetail.accountnumber }}</div>
                  <div><b>Account Type:</b> {{ accountdetail.accounttype }}</div>
                  <div><b>Amount Due:</b> {{ accountdetail.amountDue }}</div>
                  <div><b>Best Match:</b> {{ accountdetail.bestMatch }}</div>
                  <div><b>FiName:</b> {{ accountdetail.fiName }}</div>
                  <div><b>Installment Amount:</b>{{ accountdetail.installmentamount }}</div>
                  <div><b>Interest Rate:</b> {{ accountdetail.interestRate }}</div>
                  <div><b>Interest Rate Type:</b>{{ accountdetail.interestRateType }}</div>
                  <div><b>Interest YTD:</b> {{ accountdetail.interestYTD }}</div>
                  <div><b>Maturity Datey:</b>{{ accountdetail.maturityDate }}</div>
                  <div><b>Payment Due Date:</b>{{ accountdetail.paymentDueDate }}</div>
                  <div><b>Pay Off Amount:</b>{{ accountdetail.payoffAmount }}</div>
                  <div><b>term:</b> {{ accountdetail.accountnumber }}</div>
                  <div><b>Outstanding Balance:</b>{{ accountdetail.outstandingBalance }}</div>
                  <hr />
                </div>
              </template>
            </b-table-lite>
          </div></div
        >
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '@layouts/main'
import { vomFiservReportMethods } from '@state/helpers'

export default {
  components: { Layout },

  page: {
    title: '',
    meta: [{ name: 'description', content: 'VOMOrderSummarypage' }],
  },

  data() {
    return {
      showSpinner: false,
      headerTitle: 'Verification of Mortgage - Fiserv',
      breadcrumbs: [
        {
          text: 'Home',
          to: { path: '/home' },
        },
      ],
      items: [],
    }
  },
  computed: {
    ORDER_ID() {
      return this.$route.query.orderId
    },
  },
  created() {
    this.viewReport()
    this.breadcrumbs.push(
      {
        text: 'Reports',
        active: true,
      },
      {
        text: 'Usage Report',
        to: { path: '/usagereport' },
      },
      {
        text: 'VOM - Fiserv',
        active: true,
      }
    )
  },
  mounted() {},
  methods: {
    ...vomFiservReportMethods,
    viewReport() {
      this.showSpinner = true
      this.vomGenerateReport(this.ORDER_ID)
        .then((response) => {
          if (response.status === 200) {
            this.showSpinner = false
            this.items.push(response.data)
          } else {
            this.showSpinner = false
          }
        })
        .catch((error) => {
          this.showSpinner = false
          this.authError = error
        })
    },
  },
}
</script>
<style lang="scss" module>
@import '@design';
.containerWidth {
  max-width: $size-container-max-width;
}
.reasonStyle {
  width: 500px;
  margin-top: 20px;
  margin-bottom: 20px;
  line-height: 1.5rem;
  word-wrap: break-word;
  white-space: normal;
}
</style>
